export const UserRole = {
  ADMIN: "ADMIN",
  USER: "USER",
  HEADQUARTER: "HEADQUARTER", // 본사
  BRANCH: "BRANCH", // 부본사
  DISTRIBUTOR: "DISTRIBUTOR", // 총판
  STORE: "STORE", // 매장
};

export const GameType = {
  LOBBY: "LOBBY",
  CASINO: "CASINO",
  SLOT: "SLOT",
  SPORTS: "SPORTS",
  ETC: "ETC",
};
